import React, {useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';
import SwiperCore, {Navigation, Pagination} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import {useAppSelector} from 'common/hook';
import {setActiveTabs} from 'app/top-tabs-reduser';

SwiperCore.use([Navigation, Pagination]);

export const StudentsTabs = () => {
    const dispatch = useDispatch();
    const activeTab = useAppSelector((state) => state.topTabs.activeTabs);
    const swiperRef = useRef<SwiperCore | null>(null);

    const tabs = [
        {id: 0, label: 'Занятия'},
        {id: 1, label: 'Домашние задания'},
        {id: 2, label: 'Срезы'},
        {id: 3, label: 'Расписание'},
    ];

    const initialActiveTab = 0;

    const handleTabClick = (index: number) => {
        if (activeTab.includes(index)) {
            return;
        }

        const newActiveTabs = [index];
        dispatch(setActiveTabs(newActiveTabs));
        swiperRef.current?.slideTo(newActiveTabs[0]);
    };

    useEffect(() => {
        return () => {
            // Сброс активного таба при размонтировании компонента
            dispatch(setActiveTabs([0]));
        };
    }, [dispatch]);

    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current.on('slideChange', () => {
                dispatch(setActiveTabs([swiperRef.current?.activeIndex ?? 0]));
            });
        }
    }, [dispatch]);

    return (
        <Swiper
            slidesPerView={'auto'}
            loop={false}
            spaceBetween={0}
            watchOverflow={true}
            className="tabs-nav in-content"
            onSwiper={(swiper) => {
                swiperRef.current = swiper;
            }}
            initialSlide={initialActiveTab}
        >
            <div className="swiper-container">
                <div className="swiper-wrapper">
                    {tabs.map((tab) => (
                        <SwiperSlide
                            key={tab.id}
                            className={`swiper-slide ${activeTab[0] === tab.id ? 'active' : ''}`}
                            onClick={() => handleTabClick(tab.id)}
                        >
                             <span className={`tab-nav-item ${activeTab[0] === tab.id ? 'active' : ''}`}>
                                 {tab.label}
                             </span>
                        </SwiperSlide>
                    ))}
                </div>
            </div>
            {tabs.map((tab) => (
                activeTab.includes(tab.id) && (
                    <div key={tab.id}
                         className={`tab-content ${activeTab[0] === tab.id ? 'active' : ''}`}
                    />
                )
            ))}
        </Swiper>
    );
};
